import axios from "axios";
import { getHeadersConfig } from "../utils/config";
import { joinURLs } from "../utils/urlUtil";
import StateHelper from "../utils/StateHelper";

let getMostFrequentTagsAbortController = new AbortController();

export const Tags = {
  getMostFrequentTags: async (setMostFrequentTags:(mostFrequentTags:String[]) => void) => {
    const mostFrequentTagsState = StateHelper.getMostFrequentTagsState();
    if (mostFrequentTagsState && mostFrequentTagsState.length) {
      setMostFrequentTags(mostFrequentTagsState);
      return;
    }

    if (getMostFrequentTagsAbortController) getMostFrequentTagsAbortController.abort();
    getMostFrequentTagsAbortController = new AbortController();
  
    const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params = {
      "method": "getMostFrequentTags"
    };
  
    try {
      const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getMostFrequentTagsAbortController.signal });
      setMostFrequentTags(response.data);
      StateHelper.setMostFrequentTagsState(response.data);
    } catch (error:any) {
      setMostFrequentTags([]);
      StateHelper.setMostFrequentTagsState([]);
    }
  }
}